<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="main_content">
            <section class="bread_crumb">
                <div class="container">
                    <ul>
                        <li><router-link v-bind:to="'/'">Home</router-link></li>
                        <li>Vision</li>
                    </ul>
                </div>
            </section>
            <div class="mission_banner_wrapper custom-banner-section">
                <div class="about_main_image">
                    <img src="../../assets/images/vission-banner-img.png"  alt="vission-banner" />
                    <div class="about_main_title">
                        <h4>VISION</h4>
                    </div>
                    <div class="vission_banner_content">
                        <h5>To be perceived as the premier Saudi healthcare
                        corporate in providing knowledge and solutions.</h5>
                    </div>
                </div>
            </div>

            <div class="vision_core_content">
                <div class="container">
                    <div class="row">
                      <div class="col-md-12 d-flex justify-content-center">
                        <img src="../../assets/images/vision.png" alt="Vision" title="" />
                      </div>
                    </div>
                    <div class="core_value_sec" style="display:none">
                        <div class="core_value_block">
                            <h4>Core<br>Values</h4>
                        </div>
                        <div class="core_value_steps">
                            <ul>
                                <li>Knowledge is the life of the mind</li>
                                <li>Community comes first</li>
                                <li>Quality service is our job</li>
                                <li>Efficiency ensures business continuity</li>
                                <li>Creativity is more than just being different</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'


export default{
    data(){
        return {
            current_locale:this.$i18n_global.locale
        }
    },
    components:{
        HeaderMenu:HeaderMenu
    },
    methods:{

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Vision.vue